import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { cardioVersions } from "../../../enum/enums";

const CardioversionNeedCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        cardioversionNeedListParm,
        ...attributes
    } = props;

    const [cardioversionList, setCardioversionList] = useState(cardioversionNeedListParm);
    const [type, setType] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setCardioversionList(cardioversionNeedListParm);
    }, [cardioversionNeedListParm]);

    function handleAddCardioversion() {
        if (!isEditing) {
            const newCardioversionItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                month,
                year
            };

            const newCardioversionList = [...cardioversionList, newCardioversionItem];
            setCardioversionList(newCardioversionList);
            onRequestAdd(newCardioversionList);
        } else {
            const newCardioversionList = cardioversionList.map(cardioversionItem => {
                if (cardioversionItem.id === idRowEditing) {
                    return {
                        id: cardioversionItem.id,
                        type,
                        month,
                        year
                    }
                }

                return cardioversionItem;
            })
            setCardioversionList(newCardioversionList);
            onRequestAdd(newCardioversionList);
        }

        resetFields();
    }

    function handleEditCardioversion(id) {
        const editRowInfo = cardioversionList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setMonth(editRowInfo.month);
            setYear(editRowInfo.year);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeleteCardioversion(id) {
        const newCardioversionList = cardioversionList.filter(x => x.id !== id);
        setCardioversionList(newCardioversionList);
        onRequestAdd(newCardioversionList);
    }

    function resetFields() {
        setType(null);
        setMonth("");
        setYear("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Necessidade de Cardioversão</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-4">
                                <label><small>Necessidade de Cardioversão</small></label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={cardioVersions}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-3">
                                <label><small>Mês</small></label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={month}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 2) return false;
                                        setMonth(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-3">
                                <label><small>Ano</small></label>
                                <InputMask
                                    mask="9999"
                                    maskChar=" "
                                    value={year}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 4) return false;
                                        setYear(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddCardioversion}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={cardioversionList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Cardioversão</strong>
                                            </th>
                                            <th>
                                                <strong>Mês</strong>
                                            </th>
                                            <th>
                                                <strong>Ano</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            cardioversionList.map((cardioversionItem) => {
                                                return (
                                                    <tr key={cardioversionItem.id}>
                                                        <td>{cardioversionItem.type.label}</td>
                                                        <td>{cardioversionItem.month}</td>
                                                        <td>{cardioversionItem.year}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditCardioversion(cardioversionItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeleteCardioversion(cardioversionItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

CardioversionNeedCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

CardioversionNeedCard.defaultProps = {
    cardioversionNeedListParm: []
};

export default CardioversionNeedCard;